import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[addressNumber]',
    standalone: false
})
export class AddressNumberOneDirective {
	constructor(private el: ElementRef) {
		setTimeout(() => {
			this.onChange(this.el.nativeElement.value);
		}, 500);
	}

	@HostListener('change', ['$event'])
	onChange(event: Event | string): void {
		const inputValue = this.el.nativeElement.value;

		// Aplica a lógica da máscara
		const maskedValue = this.applyCustomMask(inputValue);

		// Atualiza o valor do input com a máscara aplicada
		this.el.nativeElement.value = maskedValue;
	}

	@HostListener('input', ['$event'])
	onInput(event: Event): void {
		const inputValue = this.el.nativeElement.value;

		// Aplica a lógica da máscara
		const maskedValue = this.applyCustomMask(inputValue);

		// Atualiza o valor do input com a máscara aplicada
		this.el.nativeElement.value = maskedValue;
	}

	private applyCustomMask(value: string): string {
		// Remove caracteres especiais e acentos
		const sanitizedValue = value.replace(/[^a-zA-Z0-9#]/g, '');

		// Adiciona "#" no início se ainda não estiver presente
		const maskedValue = sanitizedValue.startsWith('#') ? sanitizedValue : '#' + sanitizedValue;

		return maskedValue;
	}
}
